import React from "react";

export function aCameraInMyFace() {
  return (
    <div>
      <div className="para">
        Winter of 2019, I got rid of all my socials, taped my cameras and mics,
        switched to a tiny phone with no internet. This psychosis was partly
        drug induced, in Bombay where I was at that time, a Sophomore threatened
        to gut me with a fork because I was stopping him from going to the
        hospital to “get the drugs out of his system”.
      </div>
      <div className="para">
        It is unpleasant for me to think of the spyware I willingly carry
        everywhere. The devices in my room with no kill switches, the watermarks
        on my prints, the encrypted signatures in my code. It is so pervasive,
        even if I did go back to my Stallman levels of Paranoia and retreated
        into the woods, I’d get spied on by a drone 10km up. Society has come to
        accept these perversions as normal. Anything that could be used against
        you will be if you are reactive enough to be considered a threat. A few
        months ago I started on a list of all the changes I could make to my
        life to get rid of the spyware. I only got so far because the force of
        habit is strong. Only once last year was I able to cut down my phone
        usage to 30 mins a day and use other devices consciously with agenda.
      </div>
      <div className="imgContainer">
        <video controls width="320" height="auto">
          <source
            src="https://raw.githubusercontent.com/narengogi/nathsin-v2/master/src/assets/videos/stallman.MOV"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        <div className="imgCaption">Richard Stallman, October 2022</div>
      </div>
      <div className="para">
        I will have to slowly move these out. I do not want spyware in my house,
        and on my property. A large theme for DEFCON this year (the convention,
        not to be confused with the music festival) has been about how flock
        cameras are popping up on the sidewalks everywhere, pointed at your
        houses and your property. While there is nothing illegal about getting a
        license to install a pole on the road and mount a camera on it, even if
        it points at your house, the very idea of being spied on should be
        sufficient trigger to make us want to rethink the laws around mounting
        cameras on poles.
      </div>
      <div className="para">
        Honestly I couldn’t care less what other people feel about their digital
        privacy. Watching an average urban individual go about their day would
        make you want to puke (me, the average urban individual), it’s like
        watching a digital zombie, going from hit to hit. I solely bear the
        responsibility of finding meaning for myself, shared values are dead in
        2026, individual liberty had its glory peak in the 70s and we will never
        be the same society again.
      </div>
    </div>
  );
}
